// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import { castToString } from 'helpers/reduxFormFunctions'
import { ProjectTypeIdEnum } from 'config/enums'
import { CREATE_NEW_PROJECT } from '../constants'

const getInitialValues = ({ pathIds, projectIds }) => (dispatch, getState) => {
  const { user } = getState()

  // default the project create unit type value based on the user's default.
  const unitType = user.getIn(['defaultUnitType', 'unitType'])

  let projectTypeId = null

  // NOTE - database users can only create External PCN projects.
  if (user.getIn(['permissions', 'database'])) {
    projectTypeId = castToString(ProjectTypeIdEnum.EXTERNAL_PCN)
  }

  // NOTE - engineering users can only create Engineering projects.
  // If user is both database and engineering, project create will default to Engineering.
  if (user.getIn(['permissions', 'engineering'])) {
    projectTypeId = castToString(ProjectTypeIdEnum.ENGINEERING)
  }

  const initialValues = {
    defaultCompanyId: null,
    defaultContactId: null,
    defaultCompany: '',
    serviceContactCode: '', // is contact code
    pathIds,
    projectIds,
    projectName: '',
    projectTypeId,
    rcnNumber: '',
    unitType,
  }

  return dispatch(initialize(
    CREATE_NEW_PROJECT,
    initialValues,
  ))
}

export default getInitialValues
